import React from 'react'

export default function ReceiptsListHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #settings-btn:hover .tooltip-text { left: -10%; }

        #receipts-list-toolbar {
          display: flex;
          padding: 5px 0;
        }
      `}
      </style>
    </React.Fragment>
  )
}
